import loadable, { LoadableComponent } from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { UnsubscribeGuard } from 'modules/unsubscribe/components/UnsubscribeGuard';

const LoadableUnsubscribe: LoadableComponent<any> = loadable(
  async () => import('./Unsubscribe').then(module => module.Unsubscribe),
  {
    fallback: <OverlaySpinner />,
  },
);

export const LoadableUnsubscribeContainer = () => {
  return (
    <UnsubscribeGuard>
      <LoadableUnsubscribe />
    </UnsubscribeGuard>
  );
};
